
/* eslint-disable @typescript-eslint/no-shadow */
export namespace EmailCycleStatus {
  export enum EmailCycleStatus {
    QUEUED = "QUEUED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    STOPPED = "STOPPED",
  }

  export interface EmailCycleStatusDTO {
    case: string;
  }

  export const fromDTO = (dto: EmailCycleStatusDTO): EmailCycleStatus => {
    if (dto === undefined || dto === null) {
      throw new InvalidEmailCycleStatusError(
        `Invalid DTO ${dto} provided for EmailCycleStatus.EmailCycleStatus`
      );
    }
    switch (dto.case) {
      case "QUEUED":
        return EmailCycleStatus.QUEUED;
      case "IN_PROGRESS":
        return EmailCycleStatus.IN_PROGRESS;
      case "COMPLETED":
        return EmailCycleStatus.COMPLETED;
      case "STOPPED":
        return EmailCycleStatus.STOPPED;
      default:
        throw new InvalidEmailCycleStatusError(
          `Case ${dto.case} is not valid case of EmailCycleStatus.EmailCycleStatus`
        );
    }
  };

  export const toDTO = (emailCycleStatus: EmailCycleStatus): EmailCycleStatusDTO => {
    const enumDTO = {
      case: EmailCycleStatus[emailCycleStatus],
    };
    return enumDTO;
  };
}

export class InvalidEmailCycleStatusError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleStatusError";
  }
}
export class InvalidEmailCycleStatusQueuedError extends InvalidEmailCycleStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleStatusQueuedError";
  }
}

export class InvalidEmailCycleStatusInProgressError extends InvalidEmailCycleStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleStatusInProgressError";
  }
}

export class InvalidEmailCycleStatusCompletedError extends InvalidEmailCycleStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleStatusCompletedError";
  }
}

export class InvalidEmailCycleStatusStoppedError extends InvalidEmailCycleStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailCycleStatusStoppedError";
  }
}
